export default __webpack_public_path__ + "static/media/prt_login_img.5903bf1a.jpg";